import { HhsgSharedStuderFacility } from './facility.model';

export class HhsgSharedStuderOrganization {

	id = -1;
	name = '';
	legacyLink = '';
	isDcmAuthorized = false; // DCM = PCM
	isLemAuthorized = false;
	isSemAuthorized = false;
	isPfsAuthorized = false;
	isMMMAuthorized = false;
	isRmAuthorized = false;
	isIEAuthorized = false;
	parentOrganizationId = 0;
	dateUpdated: Date;
	userUpdated = '';
	leaderId = 0;
	abbreviation = '';
	dnnPrefix = '';
	code = '';
	address1 = '';
	address2 = '';
	city = '';
	stateId = 0;
	stateAbbreviation = '';
	zip = '';
	email = '';
	phone = '';
	fax = '';
	webSite = '';
	numberOfBeds = 0;
	dataFeedRootPath = '';
	pillarLabel = '';
	isSecureEmail: boolean;
	employeeCount = -1;
	isEmailRegistrationEnabled = false;
	allowForgotPasswordByEmail = false;
	isOlderLegacyLink = false;
	isLdapAuthentication = false;
	isSAMLEnabled = false;
	lemfyMonthStarting = 1;
	isDeleted = false;
	facilityModel: HhsgSharedStuderFacility;
	parentOrganizationName: string;
	applicationsAsString: string;
}
